import {
    links,
    routeNames,
    titles
} from '@app/router/constants';
import {
    getDefaultLayout
} from '@app/router/utils';
import WikiPage from '@pages/WikiPage.vue';

export default [
    {
        path: `${links.wiki}/:pageSlug`,
        name: routeNames.wiki,
        components: getDefaultLayout(WikiPage),
        meta: {
            title: titles.wiki
        },
    },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/router/routes/wiki.ts